import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiHost } from 'api/apiHost';
import { requestHandler } from '@/store/handleRequestLanguage';

const customBaseQuery = fetchBaseQuery({
  baseUrl: `${apiHost}`,
});

const baseQueryHandler = async (args, api) => requestHandler(customBaseQuery, args, api);

export const literatureHubApi = createApi({
  reducerPath: 'literatureHubAPI',
  baseQuery: baseQueryHandler,
  endpoints: (build) => ({
    fetchDocuments: build.query({
      query: (body) => ({
        url: '/api/library/Adviser',
        method: 'POST',
        body: body,
      }),
    }),
    fetchAuthorisedFundLiterature: build.query({
      query: (body) => ({
        url: '/api/library/authorisedFundLiterature',
        method: 'POST',
        body: body,
      }),
    }),
  }),
});

export const { useLazyFetchDocumentsQuery, useLazyFetchAuthorisedFundLiteratureQuery } =
  literatureHubApi;
